import { RouterProvider } from '@sailadv/hdata-ui';
import { useHref, useLocation, useNavigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { ThemeHelmet } from '@/app/theme/theme-helmet';
import { BoatGate } from '@/entities/boat';
import { ModalContainer } from '@/entities/modal';
import { ToastContainer } from '@/entities/toast';
import { useHasMultipleDomains, UserGate } from '@/entities/user';
import { useCurrentTheme } from '@/features/change-theme';
import { DomainSelectionPage } from '@/pages/domain-selection';
import { AppRoutes } from '@/shared/constants/app-routes.constant';
import { withChangedDom } from '@/shared/lib/hocs/with-changed-dom.hoc';

import { DeltaDataProvider } from './providers/delta-data';
import { GlobalPrefixGuard } from './providers/global-prefix-guard';
import { HtmlContent } from './providers/html-content';
import { AuthRouter } from './providers/router';
import { ScrollToTop } from './providers/router/';
import { TimezoneProvider } from './providers/timezone';

const App = withChangedDom(() => {
	const theme = useCurrentTheme();
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const hasMultipleDomains = useHasMultipleDomains();
	const isDomainSelection = pathname === AppRoutes.DomainSelection && hasMultipleDomains;

	return (
		<ThemeProvider theme={theme}>
			<RouterProvider navigate={navigate} useHref={useHref}>
				<ToastContainer />
				<ModalContainer />
				<ScrollToTop />
				<ThemeHelmet />
				<UserGate>
					{(isAuth) =>
						isAuth && isDomainSelection ? (
							<DomainSelectionPage />
						) : isAuth ? (
							<>
								<GlobalPrefixGuard />
								<BoatGate>
									<TimezoneProvider>
										<DeltaDataProvider>
											<HtmlContent />
										</DeltaDataProvider>
									</TimezoneProvider>
								</BoatGate>
							</>
						) : (
							<AuthRouter />
						)
					}
				</UserGate>
			</RouterProvider>
		</ThemeProvider>
	);
});

export { App };
